import { createApiActions } from '../../../helpers/actions';

export const getPoints = createApiActions()(
  'points/getPoints',
  'points/getPointsSuccess',
  'points/getPointsError',
  (siteId, cache) => ({ siteId, cache })
);

export const savePoints = createApiActions()(
  'points/savePoints',
  'points/savePointsSuccess',
  'points/savePointsError',
  (siteId, points) => ({ siteId, points })
);
